import AbstractEntity from "../AbstractEntity";

export default class ScreenShot extends AbstractEntity {
    _id;
    _fileId;
    _diagnosticId;


    getId() {
        return this._id;
    }

    getFileId() {
        return this._fileId;
    }

    getDiagnosticId() {
        return this._diagnosticId;
    }

    getClassName() {
        return "screen_shot";
    }
}